import React from 'react';

import MessageItem from './message_item';

import type { ActionVerdict, AssistantAction, Message } from './types';

interface Props {
  messages: Message[];
  resolveDisabled: boolean;
  showAdminDetails: boolean;
  speaking: boolean;
  onResolveAction: (action: AssistantAction, verdict: ActionVerdict) => void;
  onStopSpeaking: () => void;
}

export default function MessageList({
  messages,
  resolveDisabled,
  showAdminDetails,
  speaking,
  onResolveAction,
  onStopSpeaking,
}: Props) {
  return (
    <>
      {messages.map((message, index) => (
        <MessageItem
          key={index}
          message={message}
          resolveDisabled={resolveDisabled}
          showAdminDetails={showAdminDetails}
          showStopSpeaking={speaking && index === messages.length - 1}
          onResolveAction={onResolveAction}
          onStopSpeaking={onStopSpeaking}
        />
      ))}
    </>
  );
}
